import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';

const ListFaqPage = loadable(() => import('./ListFaqPage'), {
    fallback: <Loader/>,
});
const AddFaqPage = loadable(() => import('./AddFaqPage'), {
    fallback: <Loader/>,
});
const EditFaqPage = loadable(() => import('./EditFaqPage'), {
    fallback: <Loader/>,
});
const FaqRoute = ({ t , alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListFaqPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddFaqPage t={t} alert={alert} />} />
      <Route exact path="/edit/:id" element={<EditFaqPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
FaqRoute.propTypes = {
  t: PropTypes.func
};
export default FaqRoute;
